import axios from 'axios';

const baseUrl = window.config.API_URL;

const paymentsStripe = async (state) => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/processPayment`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
    ...state,
  });

  return response.data;
};
const addplanStripe = async (state) => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const userID = JSON.parse(localStorage.getItem('user')).userid;
  const name = state?.name;
  const description = state?.description || null;
  const order = state?.order||'';
  let monthlyPrice = +state?.monthlyPrice;
  let yearlyPrice = +state?.yearlyPrice;
  let lifetimePrice = +state?.lifeTimePrice;
  const taxesIds = state?.taxesid;
  const codesIds = state?.codesid;
  const color = state?.color||'';
  const status = state?.status==="3"?"0":state?.status;
  let trialDays = +state?.trialDays;
  const interval = state?.interval||'';
  const intervalCount = state?.intervalCount||'';
  const blocksStatusData = state?.blocksStatusData;
  monthlyPrice=parseInt(monthlyPrice,10)
  yearlyPrice=parseInt(yearlyPrice,10)
  lifetimePrice=parseInt(lifetimePrice,10)
  trialDays=parseInt(trialDays,10)
  const prices = [
    {
      type: 'month',
      value: +monthlyPrice,
    },

    {
      type: 'year',
      value: +yearlyPrice,
    },
    {
      type: 'lifetime',
      value: +lifetimePrice,
    },
  ];

  const headingCustomizationData = {
    name,
    description,
    order,
    trialDays:+trialDays,
    monthlyPrice:+monthlyPrice,
    yearlyPrice:+yearlyPrice,
    lifetimePrice:+lifetimePrice,
    taxesIds,
    codesIds,
    color,
    status,
    interval,
    amount: state?.price||'',
    intervalCount,
    blocksStatusData,
    prices,
  };

  const path = `/api/user/createPlan`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
    ...headingCustomizationData,
  });

  return response.data;
};

const gettingPaymentsPalnsList = async (page) => {
  const path = `/api/user/getProductPlans`;
  const url = baseUrl + path;
  const response = await axios.get(url);
  return response.data;
};

// rucuring checkout
const getRecurringCheckout = async (state) => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/createSubscription`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
    ...state,
  });

  return response.data;
};

// _______________creating Billing Data -----------------
const getBillingData = async (state) => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/createBillingInfo`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
    ...state,
  });

  return response.data;
};
// _______________ getBillingByUserId -----------------
const getBillingByUserId = async () => {
  const userId = JSON.parse(localStorage.getItem('user')).userid;
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getBillinginfoLastId/${userId}`;
  const url = baseUrl + path;
  const response = await axios.get(url);
  // const path = `/api/user/getBillingByUserId/${userId}`;
  // const url = baseUrl + path;
  // const response = await axios.get(url);

  return response.data;
};
// _______________ getBillinginfoLastID -----------------
const getPaymentsByUserID = async () => {
  const userId = JSON.parse(localStorage.getItem('user')).userid;
  const { token } = JSON.parse(localStorage.getItem('user'));

  const path = `/api/user/getPaymentsByUserId/${userId}`;
  const url = baseUrl + path;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};
// _______________ gettingBioBlockStatus -----------------
const gettingBioBlockStatus = async () => {
  const userId = JSON.parse(localStorage.getItem('user')).userid;
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getBioBlockStatus/${userId}`;
  const url = baseUrl + path;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};
// _______________ getAllTaxRate -----------------
const getAllTaxRate = async () => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getAllTaxRate`;
  const url = baseUrl + path;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};
// _______________ getAllDBCoupons -----------------
const getAllDBCoupons = async () => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getAllDBCoupons`;
  const url = baseUrl + path;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};
// _______________ getAllCharges -----------------
const gettingAllCharges = async () => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getAllCharges/`;
  const url = baseUrl + path;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};

const getAllDBPayments = async (page) => {
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getAllDBPayments/${page || ''}`;
  const url = baseUrl + path;
  const response = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};
// _______________ gettingBlockByPlanId -----------------
const gettingBlockByPlanId = async () => {
  const userId = JSON.parse(localStorage.getItem('user')).userid;
  const token = JSON.parse(localStorage.getItem('user')).token;
  const path = `/api/user/getBlockByPlanId/${userId}`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: ` 'Bearer' ${token}`,
    },
  });

  return response.data;
};
// _______________ getSingleTaxRate -----------------
const getSingleTaxRate = async (taxid) => {
  const taxesid=taxid||'';
  const token = JSON.parse(localStorage.getItem('user')).token;
  const path = `/api/user/getSingleTaxRate/${taxesid}`;
  const url = baseUrl + path;
  const response = await axios.get(url);

  return response.data;
};
// _______________ getSingleTaxRate -----------------
const getStripeSingleCoupon = async (couponid) => {
  const couponids=couponid||'';
  const token = JSON.parse(localStorage.getItem('user')).token;
  const path = `/api/user/getStripeSingleCoupon/${couponids}`;
  const url = baseUrl + path;
  const response = await axios.get(url);

  return response.data;
};

const editinPayments = async (data) => {
  const planeData = {
    name: data?.name,
    description: data?.description,
    color: data?.color,
    status: data?.status,
    contact: data?.contact,
    price: data?.price,
  };
  const path = `/api/user/updatePlan/${data?.planeId}`;
  const url = baseUrl + path;
  const response = await axios.put(url, planeData);
  return response.data;
};

// delete payment plan service
const deletingPaymentPlan = async (planeId) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const path = `/api/user/deletePlan/${planeId}`;
  const url = baseUrl + path;
  const response = await axios.delete(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer ' ${token}`,
    },
  });
  return response.data;
};
// _______________ applyCoupoun -----------------
const applyCoupoun = async (copData) => {
  const userId = JSON.parse(localStorage.getItem('user')).userid;
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/applyCoupoun`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    ...copData,
  });

  return response.data;
};
// _______________ getPlanByProductId -----------------
const getPlanByProductId = async (copData) => {
  const userId = JSON.parse(localStorage.getItem('user')).userid;
  const { token } = JSON.parse(localStorage.getItem('user'));
  const path = `/api/user/getPlanByProductId`;
  const url = baseUrl + path;
  const response = await axios.post(url, {
    ...copData,
  });

  return response.data;
};

const gettingBioLinkService = {
  paymentsStripe,
  addplanStripe,
  gettingPaymentsPalnsList,
  getRecurringCheckout,
  editinPayments,
  getBillingData,
  getBillingByUserId,
  getPaymentsByUserID,
  gettingBioBlockStatus,
  gettingBlockByPlanId,
  deletingPaymentPlan,
  getAllTaxRate,
  getAllDBCoupons,
  gettingAllCharges,
  getAllDBPayments,
  applyCoupoun,
  getPlanByProductId,
  getSingleTaxRate,
  getStripeSingleCoupon
};

export default gettingBioLinkService;
